export default (store) => {


  return {
    state: () => ({
      lastFolderPath: "/",
    }),
    mutations: {
      setLastFolderPath(state, payload) {
        if (typeof payload !== 'string') {
          warn ('store.mediaManager - setLastFolderPath - payload must be a string, NOT SETTING IT', {payload});
          return;
        }

        state.lastFolderPath = payload;
      },
    },
    actions: {},
    getters: {
      lastFolderPath(state) {
        return state.lastFolderPath;
      },
    },
  };
};
